// ══════════════════════════════════════════════════════════════════
//  useFilterOptions — opções dos filtros de Kanban e Leads.
//
//  loadFilterOptions agrega ~8 queries (origens, tags, sdrs, closers,
//  pipelines, stages, funnels, loss_reasons). Era chamado isolado por
//  KanbanPage e LeadsPage → refazia tudo a cada navegação. Com cache
//  (staleTime 5min) as duas telas compartilham um único fetch.
//  (achado #5 da auditoria)
// ══════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { qk } from './keys';
import { loadFilterOptions } from '@app';

const CINCO_MIN = 5 * 60 * 1000;

export function useFilterOptions(workspaceId?: string) {
  return useQuery({
    queryKey: qk.filterOptions(workspaceId ?? ''),
    queryFn: () => loadFilterOptions(workspaceId as string),
    enabled: !!workspaceId,
    staleTime: CINCO_MIN,
    gcTime: 2 * CINCO_MIN,
  });
}
